import { render, staticRenderFns } from "./TerminalDetail.vue?vue&type=template&id=6ce9077a&scoped=true&lang=pug&"
import script from "./TerminalDetail.vue?vue&type=script&lang=js&"
export * from "./TerminalDetail.vue?vue&type=script&lang=js&"
import style0 from "./TerminalDetail.vue?vue&type=style&index=0&id=6ce9077a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce9077a",
  null
  
)

export default component.exports